import "../../styles/auth/auth.css";

const EmailInput = (props = {}) => {
  const { email, setEmail, loading } = props;

  return (
    <label className="label-row">
      <div>
        Your Email <p className="red-text">*</p>
      </div>
      <input
        type="email"
        placeholder="email@domain.com"
        value={email}
        className="auth-input"
        disabled={loading}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
    </label>
  );
};

export default EmailInput;
